import { EXCLUDED_REFINEMENT_PREFIX } from "@/components/search/FilterBox/constants";

export function getBaseRefinementValue(value: string): string {
  return value.startsWith(EXCLUDED_REFINEMENT_PREFIX) ? value.slice(EXCLUDED_REFINEMENT_PREFIX.length) : value;
}

/**
 * Resolves tag conflicts using a first-in-wins rule.
 *
 * If the same base tag appears as both include (X) and exclude (-X), whichever
 * form appears first in the array wins and the other is dropped.
 *
 * Examples:
 *   ["Male", "-Male"]              → ["Male"]
 *   ["-Male", "-Female", "Male"]   → ["-Male", "-Female"]
 *   ["-Male", "-Female", "Anime"]  → ["-Male", "-Female", "Anime"]  (no conflict)
 */
export function resolveTagConflicts(values: string[]): string[] {
  const seenBaseValues = new Set<string>();
  const resolvedValues: string[] = [];
  for (const value of values) {
    const baseValue = getBaseRefinementValue(value);
    if (!seenBaseValues.has(baseValue)) {
      seenBaseValues.add(baseValue);
      resolvedValues.push(value);
    }
  }
  return resolvedValues;
}

/**
 * Strips values that use the excluded refinement prefix.
 * Used for filters that only support inclusion (language, group size).
 */
export function stripNegativeValues(values: string[]): string[] {
  return values.filter((value) => !value.startsWith(EXCLUDED_REFINEMENT_PREFIX));
}
